export default __webpack_public_path__ + "static/media/Carrot-Cake.8a4523ef.jpg";